import { Component, Input, Output, EventEmitter, OnInit, effect } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Address, COUNTRIES, AddressInputComponent } from '@shared';
import { CommonModule } from '@angular/common';
import { InputerrorsComponent } from '../../inputerrors.component';
import { getPlaceComponent } from '@shared';

@Component({
  selector: 'app-address-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputerrorsComponent, AddressInputComponent],
  template: `
    <form [formGroup]="addressForm" class="flex flex-col gap-3">
      <!-- Company/Organization name (optional) -->
      <app-inputerrors [control]="addressForm.controls.typename">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Firma / Verein / Sonstiges</span>
          <input 
            formControlName="typename"
            [class.border-benzRed-700]="addressForm.controls.typename.touched && !addressForm.controls.typename.valid"
            type="text" 
            placeholder="Optional"
            class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
        </label>
      </app-inputerrors>

      <!-- Salutation -->
      <app-inputerrors [control]="addressForm.controls.salutation">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Anrede</span>
          <select 
            formControlName="salutation"
            [class.border-benzRed-700]="addressForm.controls.salutation.touched && !addressForm.controls.salutation.valid"
            class="bg-white border-[1px] border-benzGrey-900 invalid:font-light invalid:text-benzGrey-600 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
            <option value="none">Keine Angabe</option>
            <option value="mrs">Frau</option>
            <option value="mr">Herr</option>
            <option value="other">Divers</option>
          </select>
        </label>
      </app-inputerrors>

      <!-- First Name -->
      <app-inputerrors [control]="addressForm.controls.name">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Vorname <span class="text-benzRed-700">*</span></span>
          <input 
            formControlName="name"
            [class.border-benzRed-700]="addressForm.controls.name.touched && !addressForm.controls.name.valid"
            type="text" 
            placeholder="Max"
            class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
        </label>
      </app-inputerrors>

      <!-- Last Name -->
      <app-inputerrors [control]="addressForm.controls.surname">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Nachname <span class="text-benzRed-700">*</span></span>
          <input 
            formControlName="surname"
            [class.border-benzRed-700]="addressForm.controls.surname.touched && !addressForm.controls.surname.valid"
            type="text" 
            placeholder="Mustermann"
            class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
        </label>
      </app-inputerrors>

      <!-- Address extra -->
      <app-inputerrors [control]="addressForm.controls.street_extra">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Adresszusatz</span>
          <input 
            formControlName="street_extra"
            [class.border-benzRed-700]="addressForm.controls.street_extra.touched && !addressForm.controls.street_extra.valid"
            type="text" 
            placeholder="z.B. c/o, Gebäude, Etage"
            class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
        </label>
      </app-inputerrors>

      <!-- Google Address Autocomplete -->
      <app-inputerrors [control]="addressForm.controls.street">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Adresse (zum Autofüllen)</span>
          <address-input (addressSelected)="onAddressSelected($event)"></address-input>
        </label>
      </app-inputerrors>

      <!-- Street -->
      <app-inputerrors [control]="addressForm.controls.street">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Straße <span class="text-benzRed-700">*</span></span>
          <input 
            formControlName="street"
            [class.border-benzRed-700]="addressForm.controls.street.touched && !addressForm.controls.street.valid"
            type="text" 
            placeholder="Musterstraße"
            class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
        </label>
      </app-inputerrors>

      <!-- Street Number -->
      <app-inputerrors [control]="addressForm.controls.street_nr">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Hausnummer <span class="text-benzRed-700">*</span></span>
          <input 
            formControlName="street_nr"
            [class.border-benzRed-700]="addressForm.controls.street_nr.touched && !addressForm.controls.street_nr.valid"
            type="text" 
            placeholder="123"
            class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
        </label>
      </app-inputerrors>

      <!-- ZIP Code -->
      <app-inputerrors [control]="addressForm.controls.zipcode">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Postleitzahl <span class="text-benzRed-700">*</span></span>
          <input 
            formControlName="zipcode"
            [class.border-benzRed-700]="addressForm.controls.zipcode.touched && !addressForm.controls.zipcode.valid"
            type="text" 
            pattern="[0-9]+" 
            placeholder="12345"
            class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
        </label>
      </app-inputerrors>

      <!-- City -->
      <app-inputerrors [control]="addressForm.controls.city">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Ort <span class="text-benzRed-700">*</span></span>
          <input 
            formControlName="city"
            [class.border-benzRed-700]="addressForm.controls.city.touched && !addressForm.controls.city.valid"
            type="text" 
            placeholder="Stuttgart"
            class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
        </label>
      </app-inputerrors>

      <!-- Country -->
      <app-inputerrors [control]="addressForm.controls.country">
        <label class="flex flex-col gap-1">
          <span class="text-sm font-medium">Land <span class="text-benzRed-700">*</span></span>
          <select 
            formControlName="country"
            [class.border-benzRed-700]="addressForm.controls.country.touched && !addressForm.controls.country.valid"
            class="bg-white border-[1px] border-benzGrey-900 invalid:font-light invalid:text-benzGrey-600 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-benzRed-700">
            <option disabled selected hidden value="">Bitte wählen...</option>
            @for (country of countries; track country.code) {
              <option [value]="country.code">{{ country.name }}</option>
            }
          </select>
        </label>
      </app-inputerrors>

      <!-- Action Buttons -->
      <div class="flex gap-2 mt-4">
        <button 
          type="button"
          (click)="onCancel()"
          class="flex-1 px-4 py-3 border-2 border-benzGrey-900 text-benzGrey-900 rounded-lg hover:bg-benzGrey-100 transition-colors focus:outline-none focus:ring-2 focus:ring-benzGrey-900">
          Abbrechen
        </button>
        <button 
          type="button"
          (click)="onSave()"
          [disabled]="!addressForm.valid"
          class="flex-1 px-4 py-3 bg-benzRed-700 text-white rounded-lg hover:bg-benzRed-800 disabled:bg-benzGrey-300 disabled:cursor-not-allowed transition-colors focus:outline-none focus:ring-2 focus:ring-benzRed-700">
          {{ editMode ? 'Speichern' : 'Hinzufügen' }}
        </button>
      </div>
    </form>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class AddressFormComponent implements OnInit {
  @Input() address?: Address;
  @Input() addressType: 'invoice' | 'delivery' | 'default' = 'default';
  @Input() editMode = false;
  @Output() saveAddress = new EventEmitter<Address>();
  @Output() cancel = new EventEmitter<void>();

  public countries = COUNTRIES;

  public addressForm = new FormGroup({
    typename: new FormControl(''),
    salutation: new FormControl('none'),
    name: new FormControl('', [Validators.required]),
    surname: new FormControl('', [Validators.required]),
    street: new FormControl('', [Validators.required]),
    street_nr: new FormControl('', [Validators.required]),
    street_extra: new FormControl(''),
    zipcode: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
  });

  ngOnInit(): void {
    if (this.address) {
      this.addressForm.patchValue({
        typename: this.address.typename || '',
        salutation: this.address.salutation || 'none',
        name: this.address.name || '',
        surname: this.address.surname || '',
        street: this.address.street || '',
        street_nr: this.address.street_nr || '',
        street_extra: this.address.street_extra || '',
        zipcode: this.address.zipcode || '',
        city: this.address.city || '',
        country: this.address.country || '',
      });
    }
  }

  onSave(): void {
    if (this.addressForm.valid) {
      const addressData: Address = {
        ...this.address,
        ...this.addressForm.value as Partial<Address>,
        address_type: this.addressType,
        salutation: this.address?.salutation || 'none', // Ensure salutation is always present (required by backend)
        title: this.address?.title || undefined, // Ensure title is always present (required by backend)
      };
      this.saveAddress.emit(addressData);
    } else {
      this.addressForm.markAllAsTouched();
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }

  /**
   * Handle address selection from Google Places autocomplete
   */
  onAddressSelected(place: google.maps.places.PlaceResult): void {
    const street = getPlaceComponent(place, 'route');
    const streetNumber = getPlaceComponent(place, 'street_number');
    const zipcode = getPlaceComponent(place, 'postal_code');
    const city = getPlaceComponent(place, 'locality');
    const country = getPlaceComponent(place, 'country', true);

    if (street) {
      this.addressForm.controls.street.setValue(street);
      this.addressForm.controls.street.markAsTouched();
    }
    if (streetNumber) {
      this.addressForm.controls.street_nr.setValue(streetNumber);
      this.addressForm.controls.street_nr.markAsTouched();
    }
    if (zipcode) {
      this.addressForm.controls.zipcode.setValue(zipcode);
      this.addressForm.controls.zipcode.markAsTouched();
    }
    if (city) {
      this.addressForm.controls.city.setValue(city);
      this.addressForm.controls.city.markAsTouched();
    }
    if (country) {
      this.addressForm.controls.country.setValue(country.toUpperCase());
      this.addressForm.controls.country.markAsTouched();
    }
  }
}

